import React from 'react'
import clsx from 'clsx'
import { linkPropTypes } from '../propTypes'
import Link from '../TgcLink/Link'

const DesktopLink = ({ href, label }) => {
  const linkClassNames = clsx(
    'group text-xl leading-normal font-normal transition cursor-none',
    'last:bg-brand-primary last:rounded-full',
    'last:hover:bg-black last:hover:text-brand-primary',
    'last:px-8 last:py-2'
  )

  return (
    <Link
      href={href}
      className={linkClassNames}
    >
      {label}
      <span className='block max-w-0 h-0.5 bg-brand-primary transition-[max-width] group-hover:max-w-full group-last:hidden' />
    </Link>
  )
}

export default DesktopLink

DesktopLink.propTypes = linkPropTypes

DesktopLink.defaultProps = {
  href: '/',
  label: ''
}
